'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Strings = function () {
    function Strings() {
        (0, _classCallCheck3.default)(this, Strings);
    }

    (0, _createClass3.default)(Strings, null, [{
        key: 'hasText',
        value: function hasText(instance) {
            if (instance && typeof instance === 'string') {
                return instance.replace(/(^\s*)|(\s*$)/g, '') !== '';
            }

            return false;
        }
    }, {
        key: 'trim',
        value: function trim(instance) {
            if (instance && typeof instance === 'string') {
                return instance.replace(/(^\s*)|(\s*$)/g, '');
            }

            throw new Error('The instance is not string.');
        }
    }]);
    return Strings;
}();

exports.default = Strings;
//# sourceMappingURL=Strings.js.map